import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, useOverlayContext } from 'seagull';
import NotificationActionLayout, { NotificationActionLayoutType } from '~/components/NotificationActionLayout/NotificationActionLayout';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError, errorTextsPath } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
const ApproveTeamMemberInvitation = (param)=>{
    let { invitingUserName, invitingUserEmail, invitingBusinessName, invitingBusinessId, invitationId } = param;
    const { api } = useStoreActions();
    const [loading, setLoading] = useState(false);
    const { showErrorToast } = useOverlayContext();
    const history = useHistory();
    const { cookies } = useIoContext();
    const { setAuthToken } = useStoreActions();
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { t: notifTexts } = useLocaleKeys('pages.notificationAction');
    async function sendApproveTeamMemberInvitation() {
        setLoading(true);
        const { success, error } = await handleRequest(api.business.acceptTeamInvite({
            invitationId,
            businessId: invitingBusinessId
        }));
        if (success) {
            // the accept team invite will update the auth token to the new vendor business
            await setAuthToken(cookies.getAuthToken());
            history.push(routes.home);
        } else {
            const errorText = error.hasServerError(ServerError.InvalidTeamInvitation) ? error.invalidTeamInvitationErrorText(errorTexts) : notifTexts.teamMemberApprovalFailed();
            showErrorToast(errorText, 'error-toast');
        }
        setLoading(false);
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "approve-team-member-invitation-page",
        style: {
            height: '100%'
        },
        children: /*#__PURE__*/ _jsx(NotificationActionLayout, {
            hideSignInLink: true,
            state: loading ? {
                type: NotificationActionLayoutType.Loading
            } : {
                type: NotificationActionLayoutType.BeforeAction,
                beforeAction: {
                    header: /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h5",
                        testId: "notification-before-action-header-text",
                        as: "span",
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h5",
                                weight: "bold",
                                as: "span",
                                children: [
                                    invitingUserName,
                                    ' '
                                ]
                            }),
                            "(",
                            invitingUserEmail,
                            ")",
                            notifTexts.invitationMiddle(),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h5",
                                weight: "bold",
                                as: "span",
                                children: invitingBusinessName
                            }),
                            notifTexts.invitationSuffix(),
                            /*#__PURE__*/ _jsx("br", {}),
                            notifTexts.clickToAccept()
                        ]
                    }),
                    buttonText: notifTexts.acceptInvitation(),
                    onClick: sendApproveTeamMemberInvitation
                }
            }
        })
    });
};
export default ApproveTeamMemberInvitation;
